import instance from "../api/instance";
import { logout } from "./sessionActions";

import {
  RENEW_SESSION,
  GET_RELATED_CIF,
  CLEAR_RELATED_CIF,
  UPDATE_COMPANY_NAME,
  GET_RELATED_COMPANIES,
  GET_RELATED_CIF_ALLOWED,
  CLEAR_RELATED_COMPANIES,
} from "../constants/constants";

export const getRelatedCompanies = (cif) => {
  return (dispatch) => {
    return instance
      .get(`/cif-cross/cif-cross-childs/${cif}`)
      .then((response) => dispatch({ type: GET_RELATED_COMPANIES, related: response.data.data }) )
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getCifCrossChilds = (cif, country) => {
  return (dispatch) => {
    return instance
      .get(`/cif-cross/customers/related-companies/${cif}/${country}`)
      .then((response) => {
        dispatch({
          type: GET_RELATED_CIF,
          related: response.data.data,
        });
        return response;
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getPermitedCompanies = () => {
  return (dispatch) => {
    return instance
      .get(`/cif-cross/customers/get-related-company-permission`)
      .then((response) => {
        dispatch({
          type: GET_RELATED_CIF_ALLOWED,
          companies: response.data.data,
        });
        return response;
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const changeCompanyToken = (cif, allCompany = false) => {
  return (dispatch) => {
    return instance
      .post(`/cif-cross/customers/change-related-company`, { allCompany, cifInstitution: cif  })
      .then((response) => {
        dispatch({ type: RENEW_SESSION, payload: response.data.accessWrapper });
        dispatch({ type: UPDATE_COMPANY_NAME, company: { id: response.data.id,  name: response.data.companyName, allCompanies: allCompany } });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
}

export const clearRelatedCompanies = () => {
  return dispatch => dispatch({ type: CLEAR_RELATED_COMPANIES });
}

export const clearCifCrossChilds = () => {
  return dispatch => dispatch({ type: CLEAR_RELATED_CIF });
}
